import React from 'react';
export const injectImports = ({ sduiImports, config }) => {

  const dynamicLoad = {};
  const keys = Object.keys(sduiImports);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (/Slot[A-Z]\d+Index\d+/.test(key)) {
      const [, s, i, n] = /Slot([A-Z])(\d+)Index(\d+)/.exec(key);
      const SectionIndex = s + i;
      const nAsInt = parseInt(n, 10);
      if (!dynamicLoad[SectionIndex]) {
        dynamicLoad[SectionIndex] = {};
      }
      dynamicLoad[SectionIndex][nAsInt] = sduiImports[key];
    }
  }
  let slotIndex = 0;
  let section = '';

  const slotProps = config.slots.reduce((acc, cur, index) => {

    if (cur.disabled) {
      return acc;
    }

    if (section !== cur.section) {
      slotIndex = 0;
      section = cur.section;
    }
    // eslint-disable-next-line no-plusplus
    slotIndex++;

    return {
      ...acc,
      [`slot${cur.section}${slotIndex}`]: {
        ...cur,
        slot: slotIndex,
        components: cur.isSDUI
          ? cur.components.map((com, n) => {
            if (Array.isArray(com)) {
              return com.map((cp, nd) => ({
                ...cp, load: dynamicLoad[cur.section + slotIndex][n]
              }));
            }
            return { ...com, load: dynamicLoad[cur.section + slotIndex][n] };
          })
          : cur.components,
      },
    };
  }, {});

  return {
    ...config,
    slots: slotProps,
  };
};

export const parseGrid = (gridItem) => {
  const { ...breakpoints } = gridItem;
  if (!breakpoints) return {};

  const keys = Object.keys(breakpoints);
  const classNames = keys
    .map((breakpoint) => {
      if (!breakpoints[breakpoint]) return null;
      if (breakpoint === '__typename') return null;
      const { cols, sticky, classNames: cnames = [] } = breakpoints[breakpoint];
      return (cnames || []).map((name) => {
        const suiClass = name.indexOf('sui-') === -1 ? `sui-${name}` : name;
        return breakpoint === 'default' ? suiClass : `${breakpoint}:${suiClass}`;
      }).join(' ');
    })
    .filter((val) => val);

  return classNames.join(' ');
};

export const hasSDUI = (config) => {
  return config.slots.some((slot) => {
    if (slot.isSDUI) return true;

    if (slot.isAccordion) {

      const components = slot.components;
      return components.some((headOrBody) => {
        return headOrBody.some((component) => {
          return component.isSDUI;
        });
      });
    }
    return false;
  });
};

export const getSduiComponents = (config) => {
  return config.slots.filter((slot) => {
    if (slot.isSDUI) return true;

    // @todo accordion
    // if (slot.isAccordion) {

    //   const components = slot.components as Slot[][];
    //   return components.some((headOrBody) => {
    //     return headOrBody.some((component) => {
    //       return component.isSDUI;
    //     });
    //   });
    // }
    return false;
  });
};

// when sdui data comes back from the api it has to be injected into the config prop data
// its possible sdui can change the prop values.
export const injectSduiDataToSlot = (slot, data, slotName) => {
  try {
    if (data?.slots?.[slotName]) {
      if (data.slots[slotName].component) {
        const sduiComponent = data.slots[slotName].component.data;
        const index = data.slots[slotName].component.index;
        const component = slot.components[index];
        const currentProps = component.props;

        component.props = {
          ...currentProps,
          ...sduiComponent.props,
        };
      } else if (data.slots[slotName].accordion) {
        const sduiAccordionData = data.slots[slotName].accordion;
        slot.components.forEach((headOrBody, headOrBodyIndex) => {
          (headOrBody).forEach((innerSlot, accordionIndex) => {
            (innerSlot.components).forEach((component, componentIndex) => {
              const sduiData = sduiAccordionData[headOrBodyIndex][accordionIndex];
              if (componentIndex === sduiData.index) {
                // hydrator may not be extended
                if (sduiData.data.props.hydrator) {
                  delete sduiData.data.props.hydrator;
                }
                // eslint-disable-next-line
                component.props = {
                  ...component.props,
                  ...(sduiData.data.props || {})
                };
              }
            });
          });
        });
      }
    }
  } catch (ex) {
    console.log(ex);
  }
};

export const mergeProductClientOnlyProduct = {
  productClientOnlyProduct: {
    queries: ['product', 'clientOnlyProduct'],
    fn: ({ query, mounted, allQueryKeys }) => {

      if (!mounted) return query;

      if (allQueryKeys.includes('product') && allQueryKeys.includes('clientOnlyProduct')) {
        if (query === 'product' || query === 'clientOnlyProduct') {
          return 'productClientOnlyProduct';
        }
      }

      return query;
    }
  }
};
